import React from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  const handleCustomize = () => {
    alert('Cookie customization options would be available here. For now, please accept or decline all cookies.');
  };

  if (!isVisible) return null;

  return (
    <div className={isVisible ? 'cookie-consent visible' : 'cookie-consent'}>
      <div className="cookie-content">
        <div className="cookie-text">
          <h3>We Value Your Privacy</h3>
          <p>
            We use cookies to enhance your browsing experience, analyze site traffic, and improve our services. 
            Cookies help us provide you with personalized content and ads.
          </p>
          <p>
            By clicking Accept All, you consent to our use of cookies. 
            You can customize your preferences or decline non-essential cookies. 
            For more information, please read our <Link to="/privacy-policy">Privacy Policy</Link>.
          </p>
        </div>
        
        <div className="cookie-buttons">
          <button className="cookie-btn cookie-btn-accept" onClick={handleAccept}>
            Accept All
          </button>
          <button className="cookie-btn cookie-btn-customize" onClick={handleCustomize}>
            Customize
          </button>
          <button className="cookie-btn cookie-btn-decline" onClick={handleDecline}>
            Decline
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;